export const ACCESS_TOKEN = 'APP-AUTH-KEY' // 用户token
export const CURRENT_USER = 'CURRENT-USER' // 当前用户信息
export const DESIGN_SETTING = 'DESIGN-SETTING' // 当前用户主题信息
export const APP_CONFIG = 'APP-CONFIG'
export const APP_VISIT_URL = 'APP-VISIT-URL'
